<template>
  <hm-content title="">
    <div class="table-panel flex flex-end">
      <div>
        <el-select
          clearable
          class="mr10"
          size="small"
          v-model="searchCondition.badgePublishState"
          placeholder="请选择活动状态"
        >
          <el-option label="上线" value="online"></el-option>
          <el-option label="下线" value="offline"></el-option>
          <el-option label="待审核" value="waitAudit"></el-option>
          <el-option label="已停用" value="stop"></el-option>
        </el-select>
        <el-input
          clearable
          style="width: 250px"
          v-model.trim="searchCondition.badgeName"
          placeholder="请输入活动名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    
    <div style="display: flex; justify-content: space-between; margin-bottom: 10px">
      <el-radio-group
        v-model="searchCondition.badgePublishState"
        size="small"
        @change="switchTab"
      >
        <el-radio-button label=""
          >全部({{ totalsz || 0 }})</el-radio-button
        >
        <el-radio-button label="online" >
          进行中({{ stateCount[0].count || 0 }})
        </el-radio-button>
        <el-radio-button label="waitAudit">
          未开始({{ stateCount[2].count || 0 }})
        </el-radio-button>
        <el-radio-button label="offline"
          >已结束({{ stateCount[3].count || 0 }})</el-radio-button
        >
        <el-radio-button label="stop"
          >已停用({{ stateCount[1].count || 0 }})</el-radio-button
        >
      </el-radio-group>
      <el-button type="primary" size="small" @click="listOfBenefits">权益名单列表</el-button>
    </div>
    
    <el-table :data="list" style="width: 100%" stripe border size="small">
      <el-table-column
        header-align="center"
        align="center"
        type="index"
        label="序号"
        width="50"
        :index="index => index + (currentPage - 1) * pageSize + 1"
      ></el-table-column>

      <el-table-column
        header-align="center"
        align="center"
        prop="badgeName"
        label="活动名称"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="itemText"
        label="活动类型"
        width="180"
        key="itemText"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="createTime"
        label="活动创建时间"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        width="100"
        prop="badgePublishState"
        label="活动状态"
      >
        <template slot-scope="scope">
          <span class="success" v-show="scope.row.badgePublishState === 'online'"
            >上线</span
          >
          <span class="danger" v-show="scope.row.badgePublishState === 'offline'"
            >下线</span
          >
          <span class="blue" v-show="scope.row.badgePublishState === 'waitAudit'"
            >待审核</span
          >
          <span class="danger" v-show="scope.row.badgePublishState === 'stop'"
            >已停用</span
          >
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        header-align="center"
        align="left"
      >
        <template slot-scope="scope">
          <!-- 停用 -->
          <div class="flex flex-center item-center" v-if="scope.row.badgePublishState === 'stop'">
              <el-button size="small" type="text" @click="toDetails(scope.row)"
                >查看</el-button
              >
              <el-divider direction="vertical"></el-divider>
              <el-button size="small" @click="listOfBenefits(scope.row)" type="text"
                >权益名单</el-button
              >
              <el-divider direction="vertical"></el-divider>
              <el-button size="small" type="text" @click="copy(scope.row)"
                >复制</el-button
              >
              <el-divider direction="vertical"></el-divider>
          </div>
            <!-- 上线 -->
            <div class="flex flex-center item-center" v-if="scope.row.badgePublishState === 'online'">
              <el-button size="small" type="text" @click="toDetails(scope.row)"
                >查看</el-button
              >
              <el-divider direction="vertical"></el-divider>
              <el-button size="small" @click="listOfBenefits(scope.row)" type="text"
                >权益名单</el-button
              >
              <el-divider direction="vertical"></el-divider>
              <el-button size="small" type="text" @click="copy(scope.row)"
                >复制</el-button
              >
              <el-divider direction="vertical"></el-divider>
              <el-button
                size="small"
                type="text"
                @click="updateState(scope.row, 'stop')"
                >停用</el-button
              >
          </div>
          <!-- 下线和已停用 -->
          <div class="flex flex-center item-center" v-if="scope.row.badgePublishState === 'offline' || scope.row.badgePublishState === 'deactivated'">
              <el-button size="small" type="text" @click="toDetails(scope.row)"
                >查看</el-button
              >
              <el-divider direction="vertical"></el-divider>
              <el-button size="small" type="text" @click="listOfBenefits(scope.row)"
                >权益名单</el-button
              >
              <el-divider direction="vertical"></el-divider>
              <el-button size="small" type="text" @click="copy(scope.row)"
                >复制</el-button
              >
          </div>

          <!-- 待审核 -->
          <div class="flex flex-center item-center" v-if="scope.row.badgePublishState === 'waitAudit'">
              <el-button
                size="small"
                type="text"
                @click="updateState(scope.row, 'online')"
                >上线</el-button
              >
              <el-button size="small" type="text" @click="toDetails(scope.row)"
                >查看</el-button
              >
              <el-divider direction="vertical"></el-divider>
              <el-button size="small" type="text" @click="listOfBenefits(scope.row)"
                >权益名单</el-button
              >
              <el-button size="small" type="text" @click="edit(scope.row)"
                >编辑</el-button
              >
              <el-divider direction="vertical"></el-divider>
              <el-button size="small" type="text" @click="copy(scope.row)"
                >复制</el-button
              >
          </div>         
        </template>
      </el-table-column>
    </el-table>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      title="请用微信扫一扫"
      :visible.sync="qrcodeDialogVisible"
      :modal="false"
      width="250px"
    >
      <div class="qrcode-wrapper">
        <img style="width: 100%" :src="activityCode" alt="二维码" />
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="参与活动记录"
      width="1200px"
      :visible.sync="dialogVisibleReservition"
    >
      <div class="mb10 flex flex-between">
        <el-radio-group
          v-model="spreadLogType"
          size="small"
          @change="recordTypeTab"
        >
          <el-radio-button label="1">邀请记录</el-radio-button>
          <el-radio-button label="2">红包领取记录</el-radio-button>
        </el-radio-group>
        <div>
          <el-input
            clearable
            style="width: 250px"
            v-model.trim="memberMobile"
            placeholder="请输入手机号"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="searchPart"
            >查询</el-button
          >
          <!-- <el-button
            type="success"
            size="small"
            @click="
              outputPart(spreadLogType === '1' ? '邀请记录' : '红包领取记录')
            "
            :loading="isOutputing"
            >导出</el-button
          > -->
        </div>
      </div>
      <div>
        <div class="flex mb10" v-if="spreadLogType === '2'">
          <div class="mr20">
            已发放红包
            <span class="primary">{{ redpackageMoneyInfo.sendMoney }}元</span>
          </div>
          <div class="mr20">
            红包限制
            <span class="primary">{{ redpackageMoneyInfo.totalMoney }}元</span>
          </div>
          <div class="mr20">
            剩余
            <span class="primary"
              >{{ redpackageMoneyInfo.surplusMoney }}元</span
            >
          </div>
        </div>
        <el-table
          :data="participateList"
          style="width: 100%"
          stripe
          border
          max-height="500"
          ref="tablePart"
          size="small"
          v-if="spreadLogType === '1'"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            key="joinId"
            :index="index => index + (currentPagePart - 1) * pageSizePart + 1"
          ></el-table-column>
          <!-- <el-table-column
            header-align="center"
            align="center"
            prop="gameType"
            label="活动类型"
            width="180"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.spreadTarget == 'guider'"
                >导购邀请供应商奖励活动</span
              >
              <span v-else-if="scope.row.spreadTarget == 'supplier'"
                >业务员邀请供应商奖励活动</span
              >
              <span v-else-if="scope.row.spreadTarget == 'store'"
                >采购邀请供应商奖励活动</span
              >
            </template>
          </el-table-column> -->
          <el-table-column
            header-align="center"
            align="center"
            prop="badgeName"
            label="活动名称"
            key="badgeName"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="参与手机号"
            prop="memberMobile"
            key="memberMobile"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="参与者姓名"
            prop="memberName"
            key="memberName"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="参与时间"
            prop="shareTime"
            key="shareTime"
          >
          </el-table-column>
        </el-table>
        <el-table
          :data="participateList"
          style="width: 100%"
          stripe
          border
          max-height="500"
          ref="tablePart"
          size="small"
          v-else
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            key="joinId"
            :index="index => index + (currentPagePart - 1) * pageSizePart + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="itemText"
            label="活动类型"
            width="180"
            key="itemText"
          >
            <!-- <template slot-scope="scope">
              <span v-if="scope.row.spreadTarget == 'guider'"
                >导购邀请供应商奖励活动</span
              >
              <span v-else-if="scope.row.spreadTarget == 'supplier'"
                >业务员邀请供应商奖励活动</span
              >
              <span v-else-if="scope.row.spreadTarget == 'store'"
                >采购邀请供应商奖励活动</span
              >
              <span v-else-if="scope.row.spreadTarget == 'redpackageVideoAd'"
                >微信广告激励红包</span
              >
            </template> -->
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="badgeName"
            label="活动名称"
            key="badgeName"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="邀请者奖励金额"
            prop="shareRewardMoney"
            key="shareRewardMoney"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="receiveRewardMoney"
            label="被邀请者奖励金额"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shareInfo"
            label="邀请者信息"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="receiveInfo"
            label="被邀请者手机号"
          ></el-table-column>
        </el-table>

        <div class="hm-pagination">
          <el-pagination
            background
            :total="totalPart"
            @size-change="handleSizeChangePart"
            @current-change="pagingPart"
            layout="total,sizes,  prev, pager, next, jumper"
            :current-page="currentPagePart"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="活动上线操作"
      :visible.sync="onlineDialogVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="ruleForm"
        :rules="rule"
        ref="ruleForm"
        label-width="100px"
      >
        <el-form-item label="上线验证码" prop="verificationCode">
          <el-input
            style="width: 300px"
            size="small"
            clearable
            class="mr10 ipt"
            maxlength="25"
            v-model.trim="ruleForm.verificationCode"
            placeholder="请输入验证码"
          ></el-input>
          <el-button @click="send" size="small" type="primary">
            {{ show ? "发送" : `${time}秒后获取` }}
          </el-button>
          <div class="form-item-tip">
            点击发送验证码会给禾苗管理账户邮箱发送一个验证码 <br />
            请向管理人员索取后验证提交
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submitForm('ruleForm')" size="small" type="primary">
          确 认</el-button
        >
        <el-button size="small" @click="onlineDialogVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      totalsz:'',
      rowId:'',
      medalTypeList:[],
      redpackageMoneyInfo: {},
      show: true,
      onlineDialogVisible: false,
      spreadLogType: "1",
      participateList: [],
      totalPart: 0,
      currentPagePart: 1,
      pageSizePart: 10,
      dialogVisibleReservition: false,
      gameTypeList: [
        {
          gameName: "导购邀请供应商奖励活动",
          gameCode: "guider"
        },
        {
          gameName: "业务员邀请供应商奖励活动",
          gameCode: "supplier"
        },
        {
          gameName: "采购邀请供应商奖励活动",
          gameCode: "store"
        },
        {
          gameName: "微信广告激励红包",
          gameCode: "redpackageVideoAd"
        }
      ],
      activityCode: "",
      qrcodeDialogVisible: false,
      isOutputing: false,
      stateCount: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      memberMobile: "",
      searchCondition: {
        badgePublishState: "",// online进行中  waitAudit未开始   stop停用  offline已结束
        badgeName:'',
      },
      ruleForm: {
        verificationCode: ""
      },
      rule: {
        verificationCode: {
          required: true,
          message: "请输入验证码"
        }
      },
      row: {},
      time: 59,
      timer: ""
    };
  },
  computed: {},
  watch: {},
  created() {
    if(sessionStorage.getItem('medalList240918')){
      const {badgePublishState, badgeName,pageSize,currentPage} = JSON.parse(sessionStorage.getItem('medalList240918'));
      this.searchCondition.badgePublishState = badgePublishState;
      this.searchCondition.badgeName = badgeName;
      this.pageSize = pageSize;
      this.currentPage = currentPage;
    }
    this.getTheRedEnvelopeMedal();
    this.medalsModule();
  },
  mounted() {
    this.queryList();
  },
  methods: {
    // 获取勋章类型
    async getTheRedEnvelopeMedal(){
        const {result} = await this.$store.dispatch('queryReportDataSource2')
        if(result){
          this.medalTypeList = result;
        }
      },


    medalsModule(){
        const theCreationIsSuccessful = localStorage.getItem('theCreationIsSuccessful');
          if(theCreationIsSuccessful == 2){
             this.$message({
              message: "恭喜您，操作成功！",
              type: "success"
              });
              localStorage.removeItem('theCreationIsSuccessful');
          }
      },

    async send() {
      if (this.show) {
        const { code } = await this.$store.dispatch(
          "redpackageBadgeSendOnlineMailMedal",
          {
            id: this.rowId
          }
        );
        if (code === "0") {
          this.$message({
            message: "操作成功！",
            type: "success"
          });
          this.time = 59;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.time < 1) {
              clearInterval(this.timer);
              this.show = true;
            } else {
              --this.time;
            }
          }, 1000);
        }
      }
    },
    // 提交验证码
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        let params = {
          id: this.rowId,
          badgePublishState: "online",
          verificationCode: this.ruleForm.verificationCode
        };
        const { code } = await this.$store.dispatch(
          "updateRedpBadgeInfoPublishStateMedal",
          params
        );
        if (code === "0") {
          this.$message({
            message: "操作成功！",
            type: "success"
          });
          this.onlineDialogVisible = false;
          this.ruleForm.verificationCode = "";
          this.show = true;
          clearInterval(this.timer);
          this.time = 0;
          this.queryList();
          // this.onLineInterface();
        }
      } else {
        return false;
      }
    },
    pagingPart(page) {
      this.currentPagePart = page;
      this.quertReservitionList();
    },
    listOfBenefits(){
      this.$router.push({
          name: 'ListOfBenefits',
        });
    },
    // 权益名单
    listOfBenefits(row){
      this.$router.push({
          name: 'ListOfBenefits',
          query: {
            badgeName: row.badgeName
          }
        });
    },  
    recordTypeTab() {
      this.participateList = [];
      this.totalPart = 0;
      this.pageSizePart = 10;
      this.currentPagePart = 1;
      this.quertReservitionList();
    },
    handleSizeChangePart(size) {
      this.currentPagePart = 1;
      this.pageSizePart = size;
      this.quertReservitionList();
    },
    searchPart() {
      this.currentPagePart = 1;

      this.quertReservitionList();
    },
     // 复制
     copy(row) {
      this.$router.push({
        name: 'CreateABadgeEvent',
        query: {
          spreadTarget: row.spreadTarget,
          id: row.id,
          type: "add"
        }
      });
    },
    // 编辑
    edit(row) {
      this.$router.push({
        name: 'CreateABadgeEvent',
        query: {
          spreadTarget: row.spreadTarget,
          id: row.id,
          type: "edit"
        }
      });
    },
    // 查看
    toDetails(row) {
      this.$router.push({
        name: 'CreateABadgeEvent',
        query: {
          spreadTarget: row.spreadTarget,
          id: row.id,
          type: "view"
        }
      });
    },
    // 上线
    updateState(row, type) {
      if(type === "online"){
        this.rowId = row.id;
        this.onlineDialogVisible = true;
      }else {
        this.$confirm("是否停用该活动？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            let params = {
              id: row.id,
              badgePublishState: type
            };
            this.$store
              .dispatch("editRedpackageBadgeInfoPublishState", params)
              .then(res => {
                const { code } = res;
                if (code === "0") {
                  this.$message({
                    message: "操作成功！",
                    type: "success"
                  });
                  this.queryList();
                }
              });
          })
          .catch(() => {});
      }
    },
   
    async quertReservitionList() {
      let params = {
        pageNo: this.currentPagePart,
        pageSize: this.pageSizePart,
        spreadId: this.row.id,
        spreadLogType: this.spreadLogType
      };
      if (this.spreadLogType === "1") {
        params.shareMobile = this.memberMobile;
      } else {
        params.keyWord = this.memberMobile;
      }
      const { result } = await this.$store.dispatch(
        "queryRedpackageSpreadActivityLog",
        params
      );
      if (this.spreadLogType === "1") {
        const { records, total } = result;
        this.participateList = records;
        this.totalPart = total;
      } else {
        const { logDataInfoList, redpackageMoneyInfo } = result;
        this.redpackageMoneyInfo = redpackageMoneyInfo;
        const { records, total } = logDataInfoList;
        this.participateList = records;
        this.totalPart = total;
      }
      this.$nextTick(() => {
        this.$refs.tablePart.doLayout();
        //给table加一个ref
      });
    },
    async quertReservitionAllList() {
      let params = {
        pageNo: 1,
        pageSize: 99999,
        spreadId: this.row.id,
        spreadLogType: this.spreadLogType
      };
      const { result } = await this.$store.dispatch(
        "queryAllRedpackageSpreadActivityLog",
        params
      );
      return this.spreadLogType === "1"
        ? result.records
        : result.logDataInfoList.records;
    },
    toReservitionList(row) {
      this.row = row;
      this.currentPagePart = 1;
      this.pageSizePart = 10;
      this.spreadLogType = "1";
      this.quertReservitionList();
      this.dialogVisibleReservition = true;
    },
    
    outputPart(title) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.quertReservitionAllList()
          .then(res => {
            const list = res;
            if (this.participateType === "participate") {
              list.forEach(v => {
                v.isDefaultWinner = v.isDefaultWinner === "yes" ? "是" : "否";
                v.memberInfo = v.memberName + "/" + v.memberMobile;
                v.joinType = v.joinType === "import" ? "导表参加" : "报名参加";
              });
            } else {
              list.forEach(v => {
                v.joinType = v.joinType === "import" ? "导表参加" : "报名参加";
                v.winningType =
                  v.winningType === "manual" ? "手动开奖" : "自动开奖";
                v.memberInfo = v.memberName + "/" + v.memberMobile;
              });
            }

            const tHeader = this.$refs.tablePart.columns
              .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter(o => o);
            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.tablePart.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }

            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    // 导出
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then(res => {
            const list = res;
            list.forEach(v => {
              if (v.spreadTarget === "guider") {
                v.gameType = "邀请导购";
              } else if (v.spreadTarget === "supplier") {
                v.gameType = "邀请业务员";
              } else if (v.spreadTarget === "store") {
                v.gameType = "邀请采购";
              }
              if (v.badgePublishState === "yes") {
                v.badgePublishState = "上线";
              } else {
                v.badgePublishState = "下线";
              }
            });
            const tHeader = this.$refs.table.columns
              .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter(o => o);

            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.table.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              "我的活动" + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    async queryAllList() {
      let params = {
        pageSize: 99999,
        pageNo: 1
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "redpackageSpreadActivityAllList",
        params
      );

      if (code === "0") {
        return result.pageList.records;
      }
    },


    // 获取勋章列表
    async queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryRedpackageBadgeInfoPage",
        params
      );

      if (code === "0") {
        const { pageList, groupByCountMapList } = result;
        const { records, total } = pageList;
        if(params.badgePublishState == ''){
          this.totalsz = total;
        }
        this.stateCount = groupByCountMapList;
        records.forEach((e) => {
          this.medalTypeList.forEach(itme=>{  
            if( e.badgeType == itme.itemValue){
              e['itemText'] = itme.itemText;
            }
          })
        });

        this.list = records;
        this.total = total;
      }
    },


    switchTab() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
  },
  // beforeDestroy(){
  //   console.log('离开之前调用')
  // },
  // beforeRouteLeave(to, from, next) {
  //   console.log('离开之前调用2')
  //   next();
  // },
  destroyed() {
    const objs = {...this.searchCondition,...{currentPage: this.currentPage, pageSize: this.pageSize} }
    sessionStorage.setItem('medalList240918', JSON.stringify(objs));
  },
};
</script>
<style lang="scss" scoped></style>
